/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';


export function ProfissionalNameCell({ rowData }) {
  const iniciais = rowData.nome
    ?.split(' ')
    .slice(0, 2)
    .map((n) => n[0])
    .join('');

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: '#E8F0FE',
          color: '#2563eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          flexShrink: 0
        }}
      >
        {rowData.foto_perfil_caminho ? (
          <img
            src={rowData.foto_perfil_caminho}
            alt={rowData.nome}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
              background: '#E8F0FE',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              flexShrink: 0
            }}
          />
        ) : (
          iniciais
        )}
      </div>

      <div>
        <div
          style={{
            fontWeight: 600
          }}
        >
          {rowData.nome}
        </div>

        <div
          style={{
            fontSize: 12,
            // color: '#6b7280'
          }}
        >
          {rowData.telefone1}
        </div>
      </div>
    </div>
  );
}

export function ProfissionalCell({ rowData }) {
  const iniciais = rowData.Nome
    ?.split(' ')
    .slice(0, 2)
    .map((n) => n[0])
    .join('');

  const documento = rowData['Cpf/Cnpj'];

  const tipoDocumento =
    documento?.replace(/\D/g, '').length > 11
      ? 'CNPJ'
      : 'CPF';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: '#E8F0FE',
          color: '#2563eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          flexShrink: 0
        }}
      >
        {rowData.foto_perfil_caminho ? (
          <img
            src={rowData.foto_perfil_caminho}
            alt={rowData.Nome}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
              background: '#E8F0FE',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              flexShrink: 0
            }}
          />
        ) : (
          iniciais
        )}
      </div>

      <div>
        <div
          style={{
            fontWeight: 600
          }}
        >
          {rowData.Nome}
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#6b7280'
          }}
        >
          {rowData.Email}
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#9ca3af',
          }}
        >
          <strong
            style={{
              fontWeight: 600,
              color: '#6b7280',
            }}
          >
            {tipoDocumento}:
          </strong>{' '}
          {documento}
        </div>
      </div>
    </div>
  );
}

export function ProfissionalAddressCell({ rowData }) {
  const iniciais = rowData.Nome
    ?.split(' ')
    .slice(0, 2)
    .map((n) => n[0])
    .join('');

  // const documento = rowData['Cpf/Cnpj'];

  // const tipoDocumento =
  //   documento?.replace(/\D/g, '').length > 11
  //     ? 'CNPJ'
  //     : 'CPF';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: '#E8F0FE',
          color: '#2563eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          flexShrink: 0,
          // wordWrap: 'break-word'
        }}
      >
        {rowData.foto_perfil_caminho ? (
          <img
            src={rowData.foto_perfil_caminho}
            alt={rowData.Nome}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
              background: '#E8F0FE',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              flexShrink: 0
            }}
          />
        ) : (
          iniciais
        )}
      </div>

      {/* <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {rowData.Nome}
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#6b7280',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {rowData.Cidade} - {rowData.Estado} - {rowData.Bairro}
        </div>
        <div
          style={{
            fontSize: 12,
            color: '#6b7280',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {rowData.Cidade} - {rowData.Estado} - {rowData.Bairro}
        </div>

      </div> */}
      <div>
        <div
          style={{
            fontWeight: 600
          }}
        >
          {rowData.Nome}
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#6b7280'
          }}
        >
          {rowData.Cidade} - {rowData.uf}
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#9ca3af',
          }}
        >
          <strong
            style={{
              fontWeight: 600,
              color: '#6b7280',
            }}
          >
            Bairro:
          </strong>{' '}
          {rowData.Bairro}
        </div>
      </div>
    </div>
  );
}


export function BadgeCell({ color, text }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',

        padding: '5px 12px',

        borderRadius: '999px',

        background: color,
        color: '#1a1d24',

        fontSize: 12,

        fontWeight: 600,

        minWidth: 90,
      }}
    >
      {text}
    </span>
  );
}

export function LiberacaoCell({ rowData }) {
  return (
    <div>
      <div
        style={{
          fontWeight: 500
        }}
      >
        {rowData['Pro Liberacao']}
      </div>

      <div
        style={{
          fontSize: 12,
          color: '#6b7280'
        }}
      >
        {rowData['Dt Liberacao']}
      </div>
    </div>
  );
}

export function LocationCell({ rowData }) {
  return (
    <div>
      <div
        style={{
          fontWeight: 600,
        }}
      >
        {rowData.Cidade}
      </div>

      <div
        style={{
          fontSize: 12,
          color: '#6B7280',
        }}
      >
        {rowData.Estado} • {rowData.Bairro}
      </div>
    </div>
  );
}

export function InterestCell({ rowData }) {
  const map = {
    Freelancer: {
      background: '#DBEAFE',
      text: 'Freelancer',
    },

    Emprego: {
      background: '#DCFCE7',
      text: 'Emprego',
    },

    'Emprego e Freelancer': {
      background: '#F3E8FF',
      text: 'Emprego + Freelancer',
    },
  };

  const badge =
    map[rowData.Interesse] || {
      background: '#F3F4F6',
      text: rowData.Interesse,
    };

  return (
    <BadgeCell
      color={badge.background}
      text={badge.text}
    />
  );
}

ProfissionalCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};

ProfissionalAddressCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};

BadgeCell.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

LiberacaoCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};

LocationCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};

InterestCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};